import React, { useState, useContext, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Badge,
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  useMediaQuery,
  useTheme,
  Slide,
  Tooltip,
  Divider,
} from "@mui/material";
import {
  Notifications,
  ArrowBack,
  DarkMode,
  LightMode,
  Menu as MenuIcon,
  Work as WorkIcon,
} from "@mui/icons-material";
import { Alert } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import TodayIcon from "@mui/icons-material/Today";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContextProvider";
import { logoutUser, fetchAuthRoots, fetchProfileCompletion } from "../../../services/apiService";
import DailySessions from "./TabletDailySessions";
import ShiftActions from "./TabletShiftActions";
import { checkActiveDailySession } from "../../../services/Settings/ServicesandTaxSettingsAndSessios/SessoinAndShiftsApi";
import { fetchServiceAndTaxSettings } from "../../../services/Settings/ServicesandTaxSettingsAndSessios/ServicesAndTaxApi";
import { getActiveShiftData, getActiveDailySessionData } from "../../../services/Settings/ServicesandTaxSettingsAndSessios/SessoinAndShiftsApi";
import NotificationList from "./Tabletnotification";
import { fetchNotifications } from "../../../services/Notification/NotificationApi";
import { useAuth } from "../../../context/AuthContext";
import useInternetStatus from "../../../components/useInternetStatus";



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Navbar = ({ isSidebarOpen, toggleSidebar }) => {
  const [anchorElNotifications, setAnchorElNotifications] = useState(null);
  const [anchorElProfile, setAnchorElProfile] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [username, setUsername] = useState("");
  const [branchName, setBranchName] = useState("");
  const [avatar, setAvatar] = useState("");
  const [branches, setBranches] = useState([]);
  const [branchDialogOpen, setBranchDialogOpen] = useState(false);
  const [selectedBranchId, setSelectedBranchId] = useState(localStorage.getItem("branch_id") || "");
  const [dailyStarted, setDailyStarted] = useState(() => {
    return localStorage.getItem("daily_started") === "true";
  });
  const [dailyDate, setDailyDate] = useState(() => {
    const stored = localStorage.getItem("daily_date");
    return stored || new Date().toLocaleDateString("ar-EG");
  });
  const [anchorElDaily, setAnchorElDaily] = useState(null);
  const [dailyDialogOpen, setDailyDialogOpen] = useState(false); // State to control DailySessions dialog
  const [shiftDialogOpen, setShiftDialogOpen] = useState(false); // State to control ShiftActions dialog
  const [sessionType, setSessionType] = useState(""); // حالة اليومية من الإعدادات
  const [activeDailySessionDate, setActiveDailySessionDate] = useState("");

  const navigate = useNavigate();
  const { mode, toggleTheme } = useContext(ThemeContext);
  const theme = useTheme();
  
  // ✅ كشف دقيق لجميع أحجام التابلت
  const isSmallTablet = useMediaQuery("(min-width: 600px) and (max-width: 768px)");
  const isMediumTablet = useMediaQuery("(min-width: 769px) and (max-width: 900px)");
  const isLargeTablet = useMediaQuery("(min-width: 901px) and (max-width: 1024px)");
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 1024px)");
  
  // ✅ كشف الوضع الأفقي/العمودي
  const isPortrait = useMediaQuery("(orientation: portrait)");
  const isLandscape = useMediaQuery("(orientation: landscape)");

  const [isDailyActive, setIsDailyActive] = useState(true);
  const [isLoadingDailyStatus, setIsLoadingDailyStatus] = useState(true);
  const [showShiftAlert, setShowShiftAlert] = useState(false);
  const { logout } = useAuth();

  // NEW: states for plan renewal alert
  const [planData, setPlanData] = useState(null);
  const [renewCountdown, setRenewCountdown] = useState("");
  const [showRenewAlert, setShowRenewAlert] = useState(false);
  const [isRenewExpired, setIsRenewExpired] = useState(false);
  const isOnline = useInternetStatus();


  // احصل على التوكن من localStorage
  const token = localStorage.getItem("token");
  const [unseenCount, setUnseenCount] = useState(0);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    setUsername(localStorage.getItem("username") || "مستخدم");
    setBranchName(localStorage.getItem("branch_name") || "فرع غير محدد");
    setAvatar(user.image || "");

    const loadBranches = async () => {
      try {
        const data = await fetchAuthRoots();
        setBranches(Array.isArray(data) ? data : []);
      } catch (err) {
        setBranches([]);
      }
    };
    loadBranches();

    // NEW: load plan data for renewal alerts
    const loadPlan = async () => {
      try {
        const res = await fetchProfileCompletion();
        const payload = res?.data ?? res;
        const plane = payload?.plane ?? payload;
        setPlanData(plane || null);
      } catch (err) {
        setPlanData(null);
      }
    };
    loadPlan();

    // جلب حالة اليومية من الإعدادات
    fetchServiceAndTaxSettings()
      .then(async (data) => {
        setSessionType(data.session || "");
        // تحقق من حالة الشيفت المطلوبة فقط إذا كانت اليومية ليست تلقائية
        if (data.session !== "automatic" && data.shift === "required") {
          try {
            const activeShifts = await getActiveShiftData();
            if (!activeShifts || activeShifts.length === 0) {
              setShowShiftAlert(true);
            } else {
              setShowShiftAlert(false);
            }
          } catch {
            setShowShiftAlert(true);
          }
        } else {
          setShowShiftAlert(false);
        }
      })
      .catch(() => setSessionType(""));
  }, []);

  // NEW: countdown effect for plan renewal (updates every second)
  useEffect(() => {
    const plane = planData;
    if (!plane?.end_date) {
      setRenewCountdown("");
      setShowRenewAlert(false);
      setIsRenewExpired(false);
      return;
    }

    const endDate = new Date(`${plane.end_date}T23:59:59`);
    let intervalId = null;

    const update = () => {
      const now = new Date();
      const diff = endDate - now;
      if (diff <= 0) {
        setIsRenewExpired(true);
        setShowRenewAlert(true);
        setRenewCountdown("00 يوم 00:00:00");
        return;
      }

      setIsRenewExpired(false);
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const rem = diff % (1000 * 60 * 60 * 24);
      const hours = Math.floor(rem / (1000 * 60 * 60));
      const minutes = Math.floor((rem % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((rem % (1000 * 60)) / 1000);

      setRenewCountdown(
        `${days} يوم ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
      );

      // show alert when 10 days or less
      setShowRenewAlert(days <= 10);
    };

    update();
    intervalId = setInterval(update, 1000);
    return () => clearInterval(intervalId);
  }, [planData]);

  useEffect(() => {
    // جلب عدد الإشعارات غير المقروءة
    const loadUnseenNotifications = async () => {
      if (!token) return;
      try {
        const res = await fetchNotifications(token);
        const notifications = res?.data?.notifications || [];
        const unseen = notifications.filter(n => !n.seen).length;
        setUnseenCount(unseen);
      } catch {
        setUnseenCount(0);
      }
    };
    loadUnseenNotifications();
  }, [token]);

  const notifications = [
    "طلب جديد تم إضافته",
    "تم تحديث حالة طلبك",
    "إشعار جديد من الإدارة"
  ];

const handleLogout = () => {
  logout(); // 👈 ده هيعمل clear ويخلي isAuthenticated=false
};


  const handleBranchChange = (e) => {
    const branchId = e.target.value;
    const branch = branches.find(b => String(b.id) === String(branchId));
    setSelectedBranchId(branchId);
    localStorage.setItem("branch_id", branchId);
    localStorage.setItem("branch_name", branch?.name || ""); // تغيير اسم الفرع في اللوكال استورج بناءً على branch_id
    setBranchName(branch?.name || ""); // تغيير اسم الفرع في الواجهة
    setBranchDialogOpen(false);
    window.location.reload(); // إعادة تحميل الصفحة لتطبيق التغيير
  };

  const handleDailyMenuClick = () => {
    setDailyDialogOpen(true); // Open the DailySessions dialog
  };

  const handleDailyDialogClose = () => {
    setDailyDialogOpen(false); // Close the DailySessions dialog
  };

  const handleShiftMenuClick = () => {
    setShiftDialogOpen(true); // Open the ShiftActions dialog
  };

  const handleShiftDialogClose = () => {
    setShiftDialogOpen(false); // Close the ShiftActions dialog
  };

  // ✅ إذا لم يكن تابلت، لا تعرض Navbar
  if (!isTablet) {
    return null;
  }

  // ✅ حساب أحجام النصوص والأيقونات حسب حجم الشاشة
  const getIconSize = () => {
    if (isSmallTablet) return "small";
    if (isMediumTablet) return "medium";
    return "medium";
  };

  const getFontSize = () => {
    if (isSmallTablet) return { title: "11px", subtitle: "9px" };
    if (isMediumTablet) return { title: "12px", subtitle: "10px" };
    return { title: "13px", subtitle: "11px" };
  };

  const getAvatarSize = () => {
    if (isSmallTablet) return { width: 32, height: 32, fontSize: "16px" };
    if (isMediumTablet) return { width: 34, height: 34, fontSize: "17px" };
    return { width: 36, height: 36, fontSize: "18px" };
  };

  const getAlertPadding = () => {
    if (isSmallTablet) return 0.5;
    if (isMediumTablet) return 0.6;
    return 0.6;
  };

  const getAlertFontSize = () => {
    if (isSmallTablet) return 11;
    if (isMediumTablet) return 12;
    return 13;
  };

  const fontSize = getFontSize();
  const avatarSize = getAvatarSize();

  return (
    <AppBar
      position="fixed"
      sx={{
        background: mode === "dark"
          ? "linear-gradient(135deg, rgba(30, 30, 30, 0.95) 0%, rgba(31, 29, 43, 0.95) 100%)"
          : "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(250, 250, 250, 0.95) 100%)",
        backdropFilter: "blur(12px)",
        color: mode === "dark" ? "#fff" : "#000",
        boxShadow: mode === "dark"
          ? "0 4px 20px rgba(0,0,0,0.3)"
          : "0 4px 20px rgba(0,0,0,0.08)",
        borderBottom: mode === "dark" ? "1px solid #333" : "1px solid #eee",
        top: 0,
        zIndex: 1098,
        // ✅ دعم safe area
        paddingTop: "env(safe-area-inset-top)",
        paddingLeft: "env(safe-area-inset-left)",
        paddingRight: "env(safe-area-inset-right)",
        // ✅ تحسين الأداء
        willChange: "transform",
        WebkitBackfaceVisibility: "hidden",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: isSmallTablet ? 0.5 : 1,
          py: isSmallTablet ? 0.5 : 1,
          px: isSmallTablet ? 1 : 2,
          minHeight: isSmallTablet ? 56 : isMediumTablet ? 60 : 64,
          // ✅ تحسين touch targets
          "& .MuiIconButton-root": {
            padding: isSmallTablet ? "6px" : "8px",
          },
        }}
      >
        {/* التنبيهات - صف منفصل داخل الـ Toolbar */}
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 0.3 }}>
          {!isDailyActive && !isLoadingDailyStatus && (
            <Box
              sx={{
                backgroundColor: "#f44336",
                color: "#fff",
                textAlign: "center",
                py: getAlertPadding(),
                fontSize: getAlertFontSize(),
                fontWeight: 600,
                borderRadius: isSmallTablet ? "3px" : "4px",
                animation: "pulse 1.5s infinite",
                "@keyframes pulse": {
                  "0%, 100%": { opacity: 1 },
                  "50%": { opacity: 0.8 },
                },
              }}
            >
              ⚠️ برجاء تفعيل اليومية أولاً
            </Box>
          )}
          {showShiftAlert && (
            <Box
              sx={{
                backgroundColor: "#ff9800",
                color: "#fff",
                textAlign: "center",
                py: getAlertPadding(),
                fontSize: getAlertFontSize(),
                fontWeight: 600,
                borderRadius: isSmallTablet ? "3px" : "4px",
              }}
            >
              ⚠️ برجاء فتح شيفت قبل البدء بالعمل والتأكد من تفعيل اليومية
            </Box>
          )}
          {(() => {
            if (!planData) return null;
            if (isRenewExpired) {
              return (
                <Box
                  sx={{
                    backgroundColor: "#d32f2f",
                    color: "#fff",
                    textAlign: "center",
                    py: getAlertPadding(),
                    fontSize: getAlertFontSize(),
                    fontWeight: 600,
                    borderRadius: isSmallTablet ? "3px" : "4px",
                  }}
                >
                  🚨 انتهت باقتك ({planData.plane_name || "باقة"}) — الرجاء التجديد فوراً
                </Box>
              );
            }
            if (showRenewAlert) {
              return (
                <Box
                  sx={{
                    backgroundColor: "#FFB300",
                    color: "#000",
                    textAlign: "center",
                    py: getAlertPadding(),
                    fontSize: getAlertFontSize(),
                    fontWeight: 600,
                    borderRadius: isSmallTablet ? "3px" : "4px",
                  }}
                >
                  ⏳ باقتك ستنتهي بعد {renewCountdown} — تواصل مع الدعم الفني
                </Box>
              );
            }
            return null;
          })()}
        </Box>

        {/* يسار الشاشة - أزرار التنقل */}
        <Box sx={{ display: "flex", alignItems: "center", gap: isSmallTablet ? 0.5 : 1 }}>
          <Tooltip title="رجوع" arrow>
            <IconButton 
              color="inherit" 
              onClick={() => navigate(-1)}
              size={getIconSize()}
              sx={{
                transition: "all 0.2s",
                "&:hover": {
                  transform: "scale(1.05)",
                  bgcolor: mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.04)",
                },
              }}
            >
              <ArrowBack fontSize={getIconSize()} />
            </IconButton>
          </Tooltip>
        </Box>

        {/* يمين الشاشة - التحكمات */}
        <Box 
          sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: isSmallTablet ? 0.3 : 0.5,
            flexWrap: isPortrait && isSmallTablet ? "wrap" : "nowrap",
          }}
        >
          {/* Dark/Light Mode */}
          <Tooltip title={mode === "dark" ? "وضع النهار" : "وضع الليل"} arrow>
            <IconButton 
              color="inherit" 
              onClick={toggleTheme}
              size={getIconSize()}
              sx={{
                transition: "all 0.2s",
                "&:hover": {
                  transform: "rotate(180deg)",
                  bgcolor: mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.04)",
                },
              }}
            >
              {mode === "dark" ? <LightMode fontSize={getIconSize()} /> : <DarkMode fontSize={getIconSize()} />}
            </IconButton>
          </Tooltip>

          {/* اليومية */}
          {sessionType !== "automatic" && (
            <Tooltip title="إدارة اليومية" arrow>
              <IconButton
                color={dailyStarted ? "success" : "inherit"}
                onClick={handleDailyMenuClick}
                size={getIconSize()}
                sx={{
                  bgcolor: dailyStarted
                    ? mode === "dark"
                      ? "rgba(76, 175, 80, 0.15)"
                      : "rgba(76, 175, 80, 0.08)"
                    : "transparent",
                  color: dailyStarted ? "#4CAF50" : "inherit",
                  transition: "all 0.25s",
                  "&:hover": {
                    bgcolor: dailyStarted
                      ? mode === "dark"
                        ? "rgba(76, 175, 80, 0.25)"
                        : "rgba(76, 175, 80, 0.12)"
                      : mode === "dark"
                      ? "rgba(255,255,255,0.1)"
                      : "rgba(0,0,0,0.04)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <TodayIcon fontSize={getIconSize()} />
              </IconButton>
            </Tooltip>
          )}

          {/* تبديل الفروع */}
          <Tooltip title="تبديل الفروع" arrow>
            <IconButton 
              color="inherit" 
              onClick={() => setBranchDialogOpen(true)}
              size={getIconSize()}
              sx={{
                transition: "all 0.2s",
                "&:hover": {
                  transform: "scale(1.05)",
                  bgcolor: mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.04)",
                },
              }}
            >
              <SwapHorizIcon fontSize={getIconSize()} />
            </IconButton>
          </Tooltip>

          {/* الشيفت */}
          <Tooltip title="إدارة الشيفت" arrow>
            <IconButton 
              color="inherit" 
              onClick={handleShiftMenuClick}
              size={getIconSize()}
              sx={{
                transition: "all 0.2s",
                "&:hover": {
                  transform: "scale(1.05)",
                  bgcolor: mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.04)",
                },
              }}
            >
              <WorkIcon fontSize={getIconSize()} />
            </IconButton>
          </Tooltip>

          {/* الإشعارات */}
          <Tooltip title="الإشعارات" arrow>
            <IconButton
              color="inherit"
              onClick={(e) => setAnchorElNotifications(e.currentTarget)}
              size={getIconSize()}
              sx={{
                transition: "all 0.2s",
                "&:hover": {
                  transform: "scale(1.05)",
                  bgcolor: mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.04)",
                },
              }}
            >
              <Badge 
                badgeContent={unseenCount} 
                color="error"
                sx={{
                  "& .MuiBadge-badge": {
                    fontSize: isSmallTablet ? "9px" : "10px",
                    minWidth: isSmallTablet ? "16px" : "18px",
                    height: isSmallTablet ? "16px" : "18px",
                  },
                }}
              >
                <Notifications fontSize={getIconSize()} />
              </Badge>
            </IconButton>
          </Tooltip>

          <Menu
            anchorEl={anchorElNotifications}
            open={Boolean(anchorElNotifications)}
            onClose={() => setAnchorElNotifications(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              style: {
                minWidth: isSmallTablet ? 300 : 350,
                maxHeight: isSmallTablet ? 350 : 400,
                padding: 0,
              },
            }}
          >
            <NotificationList token={token} />
          </Menu>

          {/* معلومات المستخدم */}
          <Divider 
            orientation="vertical" 
            flexItem 
            sx={{ 
              my: isSmallTablet ? 0.5 : 1,
              display: isPortrait && isSmallTablet ? "none" : "block",
            }} 
          />

          <Box
            sx={{
              textAlign: "right",
              mr: isSmallTablet ? 0.5 : 1,
              display: isPortrait && isSmallTablet ? "none" : "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              maxWidth: isSmallTablet ? "100px" : isMediumTablet ? "120px" : "150px",
            }}
          >
            <Typography 
              fontWeight="bold" 
              fontSize={fontSize.title}
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width: "100%",
              }}
            >
              {username}
            </Typography>
            <Typography 
              variant="caption" 
              sx={{ 
                fontSize: fontSize.subtitle, 
                color: "#999",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width: "100%",
              }}
            >
              📍 {branchName}
            </Typography>
          </Box>

          <Tooltip title="حسابي" arrow>
            <IconButton 
              color="inherit" 
              onClick={(e) => setAnchorElProfile(e.currentTarget)}
              sx={{
                p: isSmallTablet ? 0.5 : 1,
                transition: "all 0.2s",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              <Avatar
                src={avatar}
                sx={{
                  bgcolor: "#EA7C69",
                  width: avatarSize.width,
                  height: avatarSize.height,
                  fontSize: avatarSize.fontSize,
                  fontWeight: "bold",
                  boxShadow: "0 2px 8px rgba(234, 124, 105, 0.3)",
                }}
              >
                {username?.charAt(0) || "ع"}
              </Avatar>
            </IconButton>
          </Tooltip>

          <Menu
            anchorEl={anchorElProfile}
            open={Boolean(anchorElProfile)}
            onClose={() => setAnchorElProfile(null)}
            PaperProps={{
              sx: {
                mt: 1.5,
                minWidth: isSmallTablet ? 160 : 180,
                "& .MuiMenuItem-root": {
                  fontSize: isSmallTablet ? "12px" : "14px",
                  py: isSmallTablet ? 0.8 : 1,
                },
              },
            }}
          >
            <MenuItem>ملفي الشخصي</MenuItem>
            <MenuItem>الإعدادات</MenuItem>
            <Divider />
            <MenuItem onClick={() => setOpenDialog(true)} sx={{ color: "#f44336" }}>
              تسجيل الخروج
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>

      {/* Logout Dialog */}
      <Dialog 
        open={openDialog} 
        onClose={() => setOpenDialog(false)} 
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            minWidth: isSmallTablet ? 280 : 350,
          },
        }}
      >
        <DialogTitle 
          textAlign="center"
          sx={{ fontSize: isSmallTablet ? "16px" : "18px" }}
        >
          هل أنت متأكد من تسجيل الخروج؟
        </DialogTitle>
        <DialogContent>
          <Typography 
            textAlign="center"
            sx={{ fontSize: isSmallTablet ? "13px" : "14px" }}
          >
            سيتم إنهاء الجلسة الحالية والعودة إلى صفحة الدخول.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ gap: 1, px: 2, pb: 2 }}>
          <Button 
            onClick={() => setOpenDialog(false)} 
            variant="outlined"
            size={isSmallTablet ? "small" : "medium"}
            fullWidth={isSmallTablet}
          >
            إلغاء
          </Button>
          <Button 
            onClick={handleLogout} 
            color="error" 
            variant="contained"
            size={isSmallTablet ? "small" : "medium"}
            fullWidth={isSmallTablet}
          >
            نعم، تسجيل الخروج
          </Button>
        </DialogActions>
      </Dialog>

      {/* Branch Dialog */}
      <Dialog 
        open={branchDialogOpen} 
        onClose={() => setBranchDialogOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle 
          sx={{ 
            fontWeight: "bold", 
            color: "#EA7C69",
            fontSize: isSmallTablet ? "16px" : "18px",
          }}
        >
          تغيير الفرع
        </DialogTitle>
        <DialogContent>
          <Box sx={{ minWidth: isSmallTablet ? 200 : 250, mt: 1 }}>
            <Typography sx={{ mb: 1, fontSize: isSmallTablet ? "13px" : "14px" }}>
              اختر الفرع الحالي:
            </Typography>
            <select
              value={selectedBranchId}
              onChange={handleBranchChange}
              style={{
                width: "100%",
                padding: isSmallTablet ? "8px" : "10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: isSmallTablet ? "14px" : "1rem",
                marginBottom: "10px"
              }}
            >
              <option value="" disabled>اختر الفرع</option>
              {branches.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch.name}
                </option>
              ))}
            </select>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setBranchDialogOpen(false)} 
            variant="outlined"
            size={isSmallTablet ? "small" : "medium"}
          >
            إغلاق
          </Button>
        </DialogActions>
      </Dialog>

      {/* Daily Sessions Dialog */}
      <Dialog 
        open={dailyDialogOpen} 
        onClose={handleDailyDialogClose} 
        fullWidth 
        maxWidth="sm"
        PaperProps={{
          sx: {
            minHeight: isSmallTablet ? 300 : 350,
          },
        }}
      >
        <DialogTitle sx={{ fontSize: isSmallTablet ? "16px" : "18px" }}>
          إدارة اليومية
        </DialogTitle>
        <DialogContent>
          <DailySessions />
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleDailyDialogClose} 
            variant="outlined"
            size={isSmallTablet ? "small" : "medium"}
          >
            إغلاق
          </Button>
        </DialogActions>
      </Dialog>

      {/* Shift Actions Dialog */}
      <Dialog 
        open={shiftDialogOpen} 
        onClose={handleShiftDialogClose} 
        fullWidth 
        maxWidth="sm"
        PaperProps={{
          sx: {
            minHeight: isSmallTablet ? 300 : 350,
          },
        }}
      >
        <DialogTitle sx={{ fontSize: isSmallTablet ? "16px" : "18px" }}>
          إدارة الشيفت
        </DialogTitle>
        <DialogContent>
          <ShiftActions />
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleShiftDialogClose} 
            variant="outlined"
            size={isSmallTablet ? "small" : "medium"}
          >
            إغلاق
          </Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  );
};

export default Navbar;
